import {
  LOADER,
  MODAL,
  BOOKINGCALENDAR
} from '../../reduxs'

import apiService from '../apiService'

export const getListBooking = (param) => {
  return dispatch => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.get('rest/v2/getlist_booking', { ...param, showPrivateSubject: true }).then(res => {
      if (res.status) {
        dispatch(saveListBooking(res.data.list))
        dispatch(LOADER.action.displayLoader(false))
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION getListFloor', res)
      }
      dispatch(LOADER.action.displayLoader(false))
    })
  }
}

export const deleteBookingById = (params, func) => {
  const { bookingId, ...payload } = params

  return (dispatch) => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.delete(`rest/v2/booking/${bookingId}`, payload).then((res) => {
      if (res.status) {
        dispatch(MODAL.action.closeModalConfirm())
        func()
        dispatch(LOADER.action.displayLoader(false))
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.error('ERROR ACTION deleteBooking', res)
      }
    })
  }
}

export const saveListBooking = (list) => {
  return {
    type: BOOKINGCALENDAR.actionType.SAVE_LIST_BOOKING_CAR,
    list
  }
}

export const getAllListEvent = (params, func = () => {}) => {
  return dispatch => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.get('rest/v1/getcalendar_booking', params).then(res => {
      if (res.status) {
        dispatch(saveAllListEvent(res.data))
        func()
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION getAllListEvent', res)
        dispatch(LOADER.action.displayLoader(false))
      }
    })
  }
}

export const getAllListEventSideBar = (params) => {
  return dispatch => {
    return apiService.get('rest/v1/getcalendar_booking', params).then(res => {
      if (res.status) {
        dispatch(saveAllListEventSideBar(res.data))
      } else {
        console.log('ERROR ACTION getAllListEvent', res)
      }
    })
  }
}

export const saveAllListEvent = (data) => {
  return {
    type: BOOKINGCALENDAR.actionType.SAVE_ALL_LIST_EVENT,
    data
  }
}

export const saveAllListEventSideBar = (data) => {
  return {
    type: BOOKINGCALENDAR.actionType.SAVE_ALL_LIST_EVENT_SIDE_BAR,
    data
  }
}

export const clearAllListEvent = () => {
  return {
    type: BOOKINGCALENDAR.actionType.CLEAR_ALL_LIST_EVENT
  }
}

export const clearAllListEventSideBar = () => {
  return {
    type: BOOKINGCALENDAR.actionType.CLEAR_ALL_LIST_EVENT_SIDE_BAR
  }
}
